export const MuiButton = (mode) => {
  return {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.shape.borderRadius * 3,
          textTransform: "none",
          fontWeight: 600,
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        }),
        contained: ({ theme }) => ({
          "&.MuiButton-containedPrimary": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          },
          "&.MuiButton-containedSecondary": {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
            "&:hover": {
              backgroundColor: theme.palette.secondary.dark,
            },
          },
          // The colour rules above tie with MUI's .Mui-disabled on specificity,
          // so restate it last or disabled buttons look enabled
          "&.Mui-disabled": {
            backgroundColor: theme.palette.action.disabledBackground,
            color: theme.palette.action.disabled,
          },
        }),
        outlined: ({ theme }) => ({
          borderWidth: "1px",
          "&.MuiButton-outlinedPrimary": {
            borderColor: theme.palette.border.strong,
            color: theme.palette.primary.main,
            "&:hover": {
              borderColor: theme.palette.primary.main,
              backgroundColor: theme.palette.primary.lighter,
            },
          },
        }),
      },
    },
  };
};
